import React, { useContext } from 'react';
import { Link } from '@reach/router';
import { Flex, Tag } from '@chakra-ui/react';
import { StoreContext } from '../../context/Store';
import { jsx as ___EmotionJSX } from "@emotion/react";
const Tags = _ref => {
  let {
    tags
  } = _ref;
  const {
    storeRootPath
  } = useContext(StoreContext);
  return ___EmotionJSX(Flex, {
    flexWrap: "wrap"
  }, tags.map(tag => ___EmotionJSX(Link, {
    key: tag,
    to: `${storeRootPath}/tag/${encodeURI(tag)}`
  }, ___EmotionJSX(Tag, {
    m: 1
  }, tag))));
};
export default Tags;